_controlShowMoreNanesenieExamples();

function _controlShowMoreNanesenieExamples() {
    var
        selector = {
            moreButton: '.show-more-nanesenie-examples'
        },
        $ = jQuery
        ;

    init();

    function init() {
        bind();
    }

    function bind() {
        var
            $moreButton = $(selector.moreButton)
            ;

        $moreButton.on('click', $.proxy(onClickMoreButton, null));
    }

    function onClickMoreButton() {
        var $moreButton = $(this);

        $moreButton.parents('div').first().fadeOut(1200);

        $moreButton.parents('div').first().parents('div').first().find('img').attr('style', '');

        $moreButton.parents('div').first().parents('div').first().find('img[data-src*="."]').each(function(i, el) {
            var $el = $(el);

            $el.attr('src', $el.attr('data-src'));
        })
    }
}


// WEBPACK FOOTER //
// ./assets/javascript/nanesenie.js